module.exports = __webpack_public_path__ + "img/charge_status_97.6c70db90.png";